exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cta-comp{white-space:nowrap}.cta-comp a{width:100%;height:100%;-webkit-transition:inherit;transition:inherit}.cta-comp.button{text-transform:uppercase;height:42px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#fff}.cta-comp.button.small{height:38px}.cta-comp.white a{color:#fff}.cta-comp.black a{color:#000}", ""]);

// exports
